<template>
  <div>
    <section class="lms-container">
      <alert-new v-if="showNewAlert" @close="showNewAlert=false;getAlerts();getSent()" />
      <user-views
        v-if="showReaders"
        @close="showReaders=false; selectedReaders=[]"
        :readers="selectedReaders"
      />
      <div class="content">
        <div class="title-section-content">
          <h3>Avisos</h3>
        </div>

        <div class="text-center">
          <lms-button
            :disabled="false"
            :loading="false"
            @click="showNewAlert=true"
            v-show="userType==0 || userType == 2"
          >Novo Aviso</lms-button>
        </div>
      </div>

      <div class="content">
        <div class="title-section-content">
          <h5>Mensagens enviadas</h5>
        </div>
        <div class="topics-list">
          <div class="topic" v-for="sent in sentMessages" :key="sent.id">
            <div class="topic-description-bar">
              <span
                v-if="sent.destinationUserType == 0"
                class="topic-published-date"
              >Enviado para: Adminstrativo</span>
              <span
                v-if="sent.destinationUserType == 1"
                class="topic-published-date"
              >Enviado para: Acadêmico</span>
              <span
                v-if="sent.destinationUserType == 2"
                class="topic-published-date"
              >Enviado para: Docentes</span>

              <span class="topic-published-date">Data de envio: {{getDate(sent.creationDate)}}</span>
            </div>
            <div class="topic-description-bar" v-if="sent.courseName || sent.moduleName">
              <span
                class="topic-published-date"
              >{{(sent.courseName != null ? 'CURSO: ' + sent.courseName.slice(0,150) : '')}} {{(sent.moduleName != null ? '- MÓDULO: ' + sent.moduleName.slice(0,150) : '')}}</span>
            </div>

            <div class="topic-title-bar">
              <div class="text-content">
                <h5
                  v-if="sent.text.length<262"
                  class="cropped-text"
                  style="font-size: 14px;"
                >{{sent.text}}</h5>
                <h5
                  v-else
                  class="cropped-text"
                  style="font-size: 14px;"
                >{{ sent.text.substring(0,262)+"..." }}</h5>
              </div>

              <lms-button
                :disabled="false"
                :loading="false"
                @click="deleteAlert(sent.id)"
              >Remover</lms-button>

              <lms-button
                :disabled="false"
                :loading="false"
                @click="showReaders=true, selectedReaders = sent.readers"
                v-show="sent.readers.length > 0"
              >Visto por</lms-button>

              <!-- <div class="text-content" v-for="item in sent.readers"  :key="item.id">
                   <span>Lida por: </span>
                  <span>{{item.userName}}</span>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title-section-content">
          <h5>Mensagens recebidas</h5>
        </div>
        <div class="topics-list">
          <div class="topic" v-for="item in alertList" :key="item.id">
            <div class="topic-description-bar">
              <span class="topic-published-date">Enviado por: {{item.userName}}</span>
              <span class="topic-published-date">Data de envio: {{item.creationDate | formatDate}}</span>
            </div>

            <div class="topic-title-bar">
              <div class="text-content">
                <span class="topic-published-date">Status: {{item.read ? "Lida": "Não Lida"}}</span>
                <h5
                  v-if="item.text.length<262"
                  class="cropped-text"
                  style="font-size: 14px;"
                >{{item.text}}</h5>
                <h5
                  v-else
                  class="cropped-text"
                  style="font-size: 14px;"
                >{{ item.text.substring(0,262)+"..." }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";
import AlertNew from "./AlertNew";
import UserViews from "./UserViews";

export default {
  data() {
    return {
      showNewAlert: false,
      loading: false,
      userType: this.$store.getters.user.type,
      alertList: [],
      sentMessages: [],
      showReaders: false,
      selectedReaders: []
    };
  },
  components: {
    AlertNew,
    UserViews
  },
  methods: {
    getSent() {
      const path = this.$global.endpoint + "/user/message/getsent";
      axios
        .post(path, {})
        .then(res => {
          this.sentMessages = res.data.sentMessage;
          console.log(this.sentMessages);
        })
        .catch(error => {
          console.error(error);
        });
    },
    getAlerts() {
      const path = this.$global.endpoint + "/user/message/getall";
      axios
        .post(path, {})
        .then(res => {
          this.alertList = res.data.messages;
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteAlert(alertId) {
     console.log("deleta", alertId)
      this.saving = true;
      const path = this.$global.endpoint + "/user/message/delete";

      axios
        .post(path, {
          alertId: alertId
        })
        .then(res => {
          this.saving = false;
         
          let temp = [];

          for(let i = 0; i < this.sentMessages.length; i++){
            if(this.sentMessages[i].id != alertId){
              temp.push(this.sentMessages[i]);
            }
          }

          this.sentMessages = temp;

          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Alerta exclído com sucesso"
          });
          this.$emit("close");
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    getDate(date){

      let d = new Date(new Date(date).setHours(new Date(date).getHours() - 3))
      d = `${(d.getDate() < 10 ? '0' + d.getDate() : d.getDate())}/${((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1))}/${d.getFullYear()} ${(d.getHours() < 10 ? '0' + d.getHours() : d.getHours())}:${(d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())}`;
      return d;
    }
  },
  created() {
    this.getSent();
    this.getAlerts();
  }
};
</script>
